import { GPTGameIcon } from './types';

export const DailyBonusIcon: GPTGameIcon = (props) => (
  <svg
    width="25"
    height="26"
    viewBox="0 0 25 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <defs>
      <linearGradient
        id="paint0_linear_6342_4305"
        x1="12.41"
        y1="25.832"
        x2="12.41"
        y2="5.13272"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFD4FC" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_6342_4305"
        x1="7.53335"
        y1="25.2987"
        x2="7.53335"
        y2="7.14276"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#A90086" />
        <stop offset="1" stopColor="#FF003B" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_6342_4305"
        x1="15.9541"
        y1="25.4256"
        x2="15.9541"
        y2="7.14282"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#A90086" />
        <stop offset="1" stopColor="#FF003B" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_6342_4305"
        x1="8.58376"
        y1="7.98063"
        x2="8.58376"
        y2="5.11865"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#E82E86" />
        <stop offset="1" stopColor="#FF003B" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_6342_4305"
        x1="16.0624"
        y1="7.76885"
        x2="16.0624"
        y2="5.41724"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#E82E86" />
        <stop offset="1" stopColor="#FF003B" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_6342_4305"
        x1="7.19489"
        y1="10.2024"
        x2="7.19489"
        y2="1.87021"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#A90086" />
        <stop offset="1" stopColor="#FF003B" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_6342_4305"
        x1="17.7178"
        y1="8.13836"
        x2="17.7178"
        y2="0.158657"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#A90086" />
        <stop offset="1" stopColor="#FF003B" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_6342_4305"
        x1="12.7145"
        y1="8.34992"
        x2="12.7145"
        y2="6.5143"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#A90086" />
        <stop offset="1" stopColor="#FF2457" />
      </linearGradient>
    </defs>
    <path
      d="M23.2553 17.889C22.7374 20.4323 22.1931 22.5781 21.8842 22.8432C21.1045 23.5142 13.0191 25.8461 11.8128 25.832C10.6035 25.8207 3.46845 23.7539 2.64462 22.8432C2.54458 22.7332 2.32097 21.8929 2.05028 20.6607V20.6551C1.147 16.5496 -0.291777 8.09057 0.479099 7.62814C1.48242 7.02755 10.068 5.16938 12.9014 5.13272C15.7378 5.09325 24.0615 8.00034 24.5087 8.75319C24.7764 9.20716 24.0497 14.0091 23.2582 17.889H23.2553Z"
      fill="url(#paint0_linear_6342_4305)"
    />
    <path
      opacity="0.5"
      d="M0.479474 7.62503C-0.862205 8.3074 9.25629 11.4795 11.2923 11.4795C13.3284 11.4795 24.2031 8.95875 24.5061 8.75009C24.8092 8.54144 15.6763 5.10988 12.7076 5.13243C9.73882 5.15499 0.882566 7.4192 0.479474 7.62222V7.62503Z"
      fill="white"
    />
    <path
      opacity="0.3"
      d="M11.8132 25.8318C10.6275 25.6908 10.9482 12.5652 11.2924 12.0153C11.6367 11.4655 23.597 9.1308 24.0796 9.23795C24.5621 9.34228 22.3083 22.1803 21.8876 22.8401C21.4668 23.5027 12.3605 25.8966 11.8161 25.8318H11.8132Z"
      fill="#3A0039"
    />
    <path
      opacity="0.74"
      d="M23.2558 17.8916C22.7379 20.4321 22.1936 22.5779 21.8847 22.843C21.105 23.514 13.0196 25.8459 11.8133 25.8318C10.604 25.8206 3.46896 23.7537 2.64512 22.843C2.54508 22.733 2.32147 21.8927 2.05078 20.6605C2.13022 20.779 2.51272 22.5215 3.6808 23.1108C4.18099 23.3618 9.73895 25.2848 11.6691 25.2482C13.6022 25.2143 20.5518 23.9849 21.5551 22.4708C22.5408 20.9876 23.2293 18.01 23.2558 17.8916Z"
      fill="#9F679D"
    />
    <path
      opacity="0.5"
      d="M11.8131 25.8317C11.3718 24.9633 15.441 18.478 16.4472 17.8915C17.4505 17.305 19.569 16.6114 20.2369 17.04C20.9048 17.4686 21.8846 22.8429 21.8846 22.8429C21.8846 22.8429 20.9254 17.5898 20.4605 16.9864L24.512 8.86572C24.512 8.86572 20.5517 16.3463 20.384 16.6114C20.2163 16.8793 18.4803 16.7975 16.053 17.68L11.4454 11.911C11.4454 11.911 11.3335 11.8715 11.2894 12.0153C11.2453 12.1591 15.4233 16.8229 15.441 17.8887C15.4586 18.9574 11.6131 24.4078 11.4454 24.89C11.2776 25.3721 11.8102 25.8289 11.8102 25.8289L11.8131 25.8317Z"
      fill="#201261"
    />
    <path
      opacity="0.2"
      d="M12.6558 24.786C12.6558 24.786 15.3157 19.0169 16.5043 18.5179C17.693 18.0188 20.0351 17.3731 20.4823 17.5366C20.9295 17.7002 21.821 22.3836 21.671 22.7925C21.5209 23.2014 15.707 25.178 13.921 25.3923C12.138 25.6065 12.6558 24.786 12.6558 24.786Z"
      fill="#912790"
    />
    <path
      d="M4.25195 9.68355C4.25195 9.68355 9.84228 11.8293 10.8456 11.9365C11.8489 12.0436 22.9825 9.39876 23.668 9.10551C24.3536 8.81226 24.4448 8.78125 24.4448 8.78125C24.4448 8.78125 13.4407 11.3584 11.4311 11.1893C7.98865 10.8988 4.25195 9.68637 4.25195 9.68637V9.68355Z"
      fill="#EAD1E9"
    />
    <path
      d="M9.81836 11.5811C10.5922 11.7136 10.8952 21.3287 10.9776 21.6502C11.06 21.9716 10.6893 13.6902 11.2924 12.0153L9.81836 11.5811Z"
      fill="#EAD1E9"
    />
    <path
      d="M10.0108 11.7337C8.7927 11.0372 13.8093 11.1472 13.9564 11.2684C14.1035 11.3897 10.8758 12.464 10.0108 11.7337Z"
      fill="#FFEFFE"
    />
    <path
      opacity="0.2"
      d="M0.621775 9.23504C0.783601 8.29891 8.11282 11.5444 9.37211 13.8509C10.6314 16.1574 10.7785 23.6098 10.5578 24.4641C10.3342 25.3185 3.87888 23.6718 2.91969 21.9518C1.96051 20.229 0.321663 10.9861 0.624718 9.23504H0.621775Z"
      fill="#C49FC2"
    />
    <path
      d="M8.53372 25.1013C8.53372 25.1013 7.94821 25.3466 7.58336 25.2931C7.22146 25.2395 5.27073 24.9039 5.0736 24.6981C4.87941 24.4923 2.0254 9.92015 2.44909 9.01785C2.87278 8.11555 10.8199 7.02152 11.2906 7.15404C11.7614 7.28657 12.6529 7.76873 12.6529 7.76873C12.6529 7.76873 6.88604 9.53103 6.24463 10.0668C5.60321 10.5997 7.69517 24.7601 7.72165 24.8645C7.74813 24.9716 8.53078 25.1013 8.53078 25.1013H8.53372Z"
      fill="url(#paint1_linear_6342_4305)"
    />
    <path
      d="M14.9126 25.1972C14.9126 25.1972 15.8158 25.3974 16.0483 25.4256C16.2807 25.451 18.9288 24.6784 19.2642 24.4641C19.5996 24.2498 20.9354 10.5997 20.8265 9.77076C20.7147 8.94177 12.8794 7.15691 12.5882 7.14281C12.2969 7.1259 11.4907 7.28662 11.0994 7.58268C10.708 7.87875 16.3955 9.85253 16.7868 10.6279C17.1781 11.4034 16.1895 24.7771 16.0512 24.8702C15.9129 24.9632 14.9155 25.2001 14.9155 25.2001L14.9126 25.1972Z"
      fill="url(#paint2_linear_6342_4305)"
    />
    <path
      d="M11.5819 7.98062C10.7081 7.74377 5.41198 6.32829 5.41198 6.32829L3.84375 6.64691C3.84375 6.64691 4.07325 5.98147 4.25567 5.90252C4.43809 5.82357 8.28365 4.99176 8.98097 5.13839C9.67829 5.28783 13.3297 7.66482 13.3297 7.66482L11.5849 7.98344L11.5819 7.98062Z"
      fill="url(#paint3_linear_6342_4305)"
    />
    <path
      d="M20.8318 7.06394C20.8318 7.06394 20.8259 6.74531 20.7141 6.54794C20.6023 6.35338 17.2305 5.44262 16.8951 5.41724C16.5596 5.39186 11.293 7.31489 11.293 7.31489C11.293 7.31489 12.1609 7.68144 12.7582 7.76603C13.3555 7.85062 19.8785 6.75377 20.0168 6.75377C20.1551 6.75377 20.8318 7.06394 20.8318 7.06394Z"
      fill="url(#paint4_linear_6342_4305)"
    />
    <path
      opacity="0.74"
      d="M8.5327 25.1016C8.5327 25.1016 7.63825 25.3046 7.37933 25.2595C7.12041 25.2144 5.27855 10.8256 5.4286 10.0332C5.57572 9.23809 11.731 8.05664 11.731 8.05664C11.731 8.05664 16.3356 9.89789 16.7446 10.2165C17.1536 10.538 16.8711 12.2298 16.8711 12.2298C16.8711 12.2298 16.6975 10.834 16.3592 10.5154C16.0208 10.194 13.3286 8.84616 12.0281 8.89973C11.2337 8.93357 10.4834 10.194 9.35654 10.5774C8.63863 10.8228 6.87032 10.0473 6.61434 10.4506C5.9641 11.4826 7.84127 24.8394 7.98838 24.9466C8.13844 25.0537 8.52976 25.1016 8.52976 25.1016H8.5327Z"
      fill="#2E264D"
    />
    <path
      opacity="0.74"
      d="M12.713 8.51062C12.713 8.51062 17.0705 8.91947 19.8039 8.56983C22.5343 8.22019 21.0691 7.14307 21.0691 7.14307L11.998 8.19199L12.713 8.51344V8.51062Z"
      fill="#27213A"
    />
    <path
      d="M13.1295 7.98328C13.1295 7.98328 13.1236 7.98328 13.1206 7.98328C13.103 7.97764 13.053 7.98328 12.9735 8.01148C12.9382 8.02276 12.8941 8.03967 12.8441 8.05659C11.8437 8.44006 8.5042 10.0952 7.92457 10.1995C7.78629 10.2249 7.48323 10.1826 7.08603 10.0952C5.55604 9.77096 2.62847 8.80945 2.41369 8.57542C2.143 8.27935 -0.17846 2.60051 2.66967 1.92942C4.4468 1.51211 6.88889 3.53946 8.76901 5.09311C9.90473 6.03488 10.8374 6.80465 11.2964 6.76518C11.2964 6.76518 11.9908 7.20787 12.5263 7.56033C12.6146 7.61672 12.6969 7.67311 12.7734 7.72669C12.8853 7.79718 12.9794 7.86203 13.0412 7.90714C13.0971 7.94944 13.1324 7.97482 13.1324 7.98328H13.1295Z"
      fill="url(#paint5_linear_6342_4305)"
    />
    <path
      opacity="0.5"
      d="M7.88054 9.85292C6.89488 10.2167 6.24463 5.31041 6.43 4.52371C6.61536 3.73702 9.86952 7.7438 11.8909 7.76917C13.9122 7.79455 8.09533 9.77397 7.88054 9.85292Z"
      fill="#450045"
    />
    <path
      opacity="0.74"
      d="M13.1279 7.77179L13.0366 7.90713L13.0161 7.93533L12.966 8.00864L12.8366 8.05376C11.8362 8.43723 8.49671 10.0924 7.91708 10.1967C7.7788 10.2221 7.47574 10.1798 7.07854 10.0924C6.36062 8.69382 4.73942 2.74711 6.96673 4.0921C7.51399 4.422 8.13187 4.76036 8.76152 5.09027C9.89724 6.03204 10.8299 6.80181 11.2889 6.76234C11.2889 6.76234 11.9833 7.20503 12.5188 7.55749C12.2069 7.24168 12.0333 6.89486 12.001 6.82719C12.4511 7.09506 12.7983 7.33474 12.9807 7.53211C13.0661 7.62234 13.1161 7.7013 13.1279 7.77179Z"
      fill="#2E001E"
    />
    <path
      d="M20.5954 7.41089C20.001 8.0002 13.8517 8.28499 13.1014 8.06223C13.0455 8.04531 12.9867 8.02276 12.9337 7.99456C12.9337 7.99456 12.9278 7.99456 12.9249 7.99456C12.8984 7.98046 12.869 7.96918 12.8425 7.95226C12.763 7.90715 12.6924 7.85358 12.6248 7.8C12.5541 7.73797 12.4894 7.67311 12.4306 7.60826C12.1716 7.31783 12.0304 6.99639 12.0039 6.93436C12.0039 6.9259 11.998 6.92308 11.998 6.92308C12.5453 6.91744 14.702 1.09761 15.4317 0.488559C16.1202 -0.0838364 20.7837 0.122003 22.6638 0.984826C22.8698 1.07788 23.0345 1.17374 23.1522 1.28371C24.4086 2.40313 21.2133 6.81029 20.5983 7.41935L20.5954 7.41089Z"
      fill="url(#paint6_linear_6342_4305)"
    />
    <path
      opacity="0.5"
      d="M13.1074 7.69277C13.1074 7.69277 15.2847 7.13729 17.1148 6.24909C19.8482 4.92102 21.1663 2.17747 22.305 2.0534C23.4937 1.9237 21.7048 6.64385 19.5275 7.28674C17.5414 7.87041 13.1074 7.69558 13.1074 7.69558V7.69277Z"
      fill="#20041F"
    />
    <path
      opacity="0.74"
      d="M20.5956 7.41108C20.0013 8.0004 13.8519 8.28518 13.1016 8.06243C13.0457 8.04551 12.9869 8.02295 12.9339 7.99476C12.9339 7.99476 12.9281 7.99476 12.9251 7.99476C12.9104 7.98912 12.8692 7.99758 12.8015 8.02013L12.7162 8.15547L12.6927 8.06243L12.625 7.79738C12.625 7.78046 12.6309 7.76918 12.6368 7.7579C12.6632 7.69586 12.725 7.63665 12.8162 7.57462C13.5459 7.10091 16.2911 6.5539 18.0623 4.92412C20.372 2.79526 21.1311 1.18804 22.6582 0.976562C22.8641 1.06961 23.0289 1.16548 23.1466 1.27545C24.4029 2.39486 21.2076 6.80203 20.5927 7.41108H20.5956Z"
      fill="#2D071F"
    />
    <path
      d="M10.9785 6.7004C10.9785 6.7004 12.6762 6.28026 13.6795 6.7004C14.6828 7.12053 14.4592 7.83673 14.3474 8.15535C14.2356 8.47398 12.2319 8.31044 12.2319 8.31044C12.2319 8.31044 12.3496 7.94388 12.1849 7.42224C12.0171 6.90341 10.9785 6.7004 10.9785 6.7004Z"
      fill="url(#paint7_linear_6342_4305)"
    />
    <path
      opacity="0.74"
      d="M12.6348 6.61022C12.6348 6.61022 13.7617 4.29808 14.6826 2.56115C15.683 0.674787 19.2931 1.52633 19.2196 3.01794C19.149 4.45598 14.8503 6.64124 14.1942 6.7371C13.5557 6.83015 12.6348 6.61304 12.6348 6.61304V6.61022Z"
      fill="#FF5CC5"
      fillOpacity="0.4"
    />
    <path
      opacity="0.74"
      d="M13.3223 6.72548C13.3223 6.72548 14.4227 6.49708 14.9964 5.82318C15.5908 5.12108 15.2701 2.91045 14.8375 2.99504C14.4139 3.07963 12.6367 6.60987 12.6367 6.60987L13.3223 6.72548Z"
      fill="#FF5CC5"
    />
    <path
      opacity="0.3"
      d="M1.7125 2.52449C1.48594 2.92206 4.2252 2.94744 4.86662 3.8018C5.50803 4.65617 5.88465 3.89485 6.39954 3.8018C6.91444 3.70875 4.51649 2.17203 3.22188 2.14665C1.92434 2.12127 1.7125 2.52731 1.7125 2.52731V2.52449Z"
      fill="white"
    />
    <path
      opacity="0.3"
      d="M15.0175 1.28932C14.7998 1.62768 17.2478 0.936857 18.4629 1.51207C19.7163 2.10421 20.855 1.59949 21.3287 1.14552C21.8171 0.680269 16.062 -0.346101 15.0146 1.28932H15.0175Z"
      fill="white"
    />
    <path
      opacity="0.74"
      d="M19.1655 4.83382C18.0445 5.92503 19.8217 7.14032 20.1394 7.05573C20.4601 6.97114 22.7669 4.315 22.508 2.81492C22.2432 1.2782 21.2222 2.83466 19.1655 4.83382Z"
      fill="#2D001D"
    />
    <path
      opacity="0.74"
      d="M6.65622 7.30365C6.75331 7.72097 11.0226 7.82811 11.2932 7.7689C11.5639 7.70968 9.4249 6.82148 8.20091 5.5921C6.97398 4.36272 6.54147 4.34298 6.4326 4.52344C6.32374 4.70108 6.58266 6.98503 6.65622 7.30365Z"
      fill="#2A001B"
    />
    <path
      d="M0.794775 13.8624C0.794775 13.8624 0.235742 9.74002 0.582931 8.71366C0.93012 7.6873 1.32438 7.30664 1.32438 7.30664C1.32438 7.30664 0.588815 7.41943 0.356375 7.64782C0.123935 7.87621 0.126877 9.22402 0.794775 13.8652V13.8624Z"
      fill="#92BDFF"
    />
    <path
      d="M0.355771 7.8115C0.376367 8.1414 0.700017 8.20626 0.770632 8.13859C0.841247 8.07091 1.10017 7.47314 1.10017 7.47314C1.10017 7.47314 0.338117 7.50698 0.355771 7.8115Z"
      fill="#D6E6FF"
    />
  </svg>
);
